import { FC, useEffect } from "react";
import { I_formNode, useForm } from "./../../../components/aio/aio-input";
import { useRootFreelancerProvider } from "../context";

export const CitiesForm: FC<{
    data: { accessCities?: { id: number }[], accessProvinces?: { id: number }[] },
    onChange: (v: { accessCities: { id: number }[], accessProvinces: { id: number }[] }) => void,
    setDisabled: (v: boolean) => void
}> = (props) => {
    const { options, cities } = useRootFreelancerProvider()
    const form = useForm<{ cities: number[], provinces: number[] }>({
        data: {
            cities: props.data.accessCities.map((o) => o.id),
            provinces: props.data.accessProvinces.map((o) => o.id)
        },
        fa: true,
        onChange: (data) => props.onChange({
            accessCities: data.cities.map((id) => ({ id })),
            accessProvinces: data.provinces.map((id) => ({ id })),
        }),
        option: {
            labelType: () => 'online'
        },
        inputs: {
            provinces: {
                label: 'استان', field: 'provinces', type: 'select', multiple: true, required: true,
                options: options.provinces, text: 'انتخاب استان', option: { text: (option) => option.value, value: (option) => option.key }
            },
            cities: {
                label: 'شهر', field: 'cities', type: 'select', multiple: true, required: true,
                search: 'جستجو', options: cities, text: 'انتخاب شهر', option: { text: (option) => option.text, value: (option) => option.id }
            }
        }
    })
    useEffect(() => {
        props.setDisabled(!!form.errorsList.length)
    }, [form.errorsList.length])   
    return (
        <>{
            form.render.layout({
                v: [
                    {
                        h: [
                            { flex: 1, input: 'provinces' },
                            { flex: 1, input: 'cities' }
                        ]
                    }
                ]
            })
        }</>
    )
}